import { createAction } from 'redux-actions';

export const formsLoadExisting = createAction('FORMS_LOADEXISTING');
export const formsLoaded = createAction('FORMS_LOADED');

export const formSelect = createAction('FORM_SELECT');
